import { useCampaignListingByType, ICampaignType } from '~/modules/campaign';

export const useCampaignPriceListing = () => useCampaignListingByType(ICampaignType.PRICE);
